webpackJsonp([207535620969118],{

/***/ 1844:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"LocationKpi","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"data","type":{"kind":"SCALAR","name":"JSON","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"date","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-location-kpi-80ce6764e1959dfa39ac.js